import { useQuery } from '@tanstack/react-query'
import { Alert, Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { InArrivo, TitoloPagina } from '../layout/Pagina'
import { elencaCredenziali, type StatoCredenziale } from './gestione.api'

const PORTALI: Record<string, string> = { edistribuzione: 'E-Distribuzione' }

const STATI: Record<StatoCredenziale, { testo: string; colore: 'success' | 'warning' | 'error' }> = {
  valida: { testo: 'Valida', colore: 'success' },
  password_scaduta: { testo: 'Password scaduta', colore: 'warning' },
  non_valida: { testo: 'Non valida', colore: 'error' },
}

export function Credenziali() {
  const { data: righe = [], error, isLoading } = useQuery({ queryKey: ['credenziali'], queryFn: elencaCredenziali })
  return (
    <Stack spacing={2.5}>
      <TitoloPagina
        titolo="Gestione credenziali"
        sottotitolo="Accessi ai portali dei distributori e del GSE usati per scaricare letture e produzione. Le password restano cifrate."
        azioni={<InArrivo etichetta="Aggiungi credenziali" />}
      />
      {error && <Alert severity="error">{error.message}</Alert>}
      <Paper variant="outlined">
        <TableContainer>
          <Table size="small" aria-label="Credenziali dei portali">
            <TableHead>
              <TableRow>
                <TableCell>Portale</TableCell>
                <TableCell>Utente</TableCell>
                <TableCell>Stato</TableCell>
                <TableCell align="right">Impianti collegati</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {righe.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{PORTALI[r.portale] ?? r.portale}</TableCell>
                  <TableCell>{r.username}</TableCell>
                  <TableCell><Chip size="small" color={STATI[r.stato].colore} label={STATI[r.stato].testo} /></TableCell>
                  <TableCell align="right">{r.impianti}</TableCell>
                </TableRow>
              ))}
              {!isLoading && righe.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography color="text.secondary" sx={{ py: 2 }}>
                      Nessuna credenziale salvata. Senza credenziali gli impianti restano fra i non configurati del Controllo consumi.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Stack>
  )
}
